import React, {useState, useEffect} from "react";
import brands1 from "../assets/images/brands1.jpg";
import {Link} from "react-router-dom";
import logo from "../assets/images/logo.svg";
import MotevafaImg from "../assets/images/motevafa.jpg";
import Footer from "./Footer";
import TopNav from "./TopNav";

import sia from "../services/Api";
import {data} from "jquery";
import LoaderView from "../tools/LoaderView";

const StateSingle = (props) => {
    const [irCities, setIrCities] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const [stateName, setStateName] = useState();
    const [search, setSearch] = useState('');

    useEffect(() => {
        getData()
    }, []);

    const getData = async () => {
        setLoading(true)

        const search = props.location.search
        const params = new URLSearchParams(search)
        const state_nameEn = params.get('enName')
        setStateName(params.get('name'))

        const data = {
            params: {
                state_nameEn: state_nameEn,
            },
        };

        await sia
            .getDataFromServer("/city", data)
            .then((res) => {
                setIrCities(res.data);
            })
            .catch((err) => {
                // console.log(err);
            });
        setLoading(false)
    }

    return (
        <>
            <header>
                <div className="pagewrapper slim1" id="header-slim">
                    <div className="container">
                        <TopNav/>
                    </div>
                </div>
            </header>
            <div className="clear"/>
            <div className="pagewrapper" id="center-search">
                <div className="container">
                    <form onSubmit={() => window.location.assign('/d-list?s=' + search)} action id="center-search-form"
                          method="get">
                        <input
                            type="text"
                            name="s"
                            placeholder="کد متوفی را جستجو کنید"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            className="text radius50 box-sizing"
                        />
                        <input type="submit" value="جستجو" className="btn ease radius50"/>
                    </form>
                    <a href="#" title className="link-btn ease box-sizing radius50">
                        {localStorage.getItem('token') ? 'ثبت یادبود' : 'ورود و ثبت نام رایگان صفحه یادبود'}
                    </a>
                </div>
            </div>
            <div className="pagewrapper" id="motevafa-list">
                {isLoading ? <LoaderView/> : <div className="container">
                    <h2 className="main-title">استان {stateName}</h2>
                    <ul className="list-items">
                        {irCities.map((item) => (
                            <li key={item.id} className="item">
                                <Link
                                    className="ease box-sizing radius10"
                                    to={`/city?enName=` + item.nameEn + '&name=' + item.name}
                                >
                                    {item.name + " " + item.deadCount}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>}
            </div>
            <div className="clear"/>
            <Footer/>
        </>
    );
};

export default StateSingle;
